export const toValidHtmlId = str => {
    return str.replace(/\W/g, "_");
};

export const extractTextFromHtml = htmlString => {
    return new DOMParser().parseFromString(htmlString.replace("<br>", "\n"), "text/html").documentElement.textContent;
};
